













































































































import SectionHeader from "../SectionHeader.vue";
import { Component, Vue, Watch} from 'vue-property-decorator';
import * as monaco from 'monaco-editor';
import {editor} from "monaco-editor";
import {curCoreClient, CoreClient} from '@/services/CoreClient';

import { IconList, LoraParser, Info } from "@/types/core";
import EnterpriseId from "@/components/EnterpriseId.vue";
import {validate} from 'vee-validate'
import tippy from "tippy.js";
import {Instance} from "tippy.js";
import LoraParserDelete from "@/components/loraParser/LoraParserDelete.vue";
import Loading from "@/components/Loading.vue";
import Editor from "@/components/loraParser/Editor.vue";
import KeyValue from "@/components/KeyValue.vue";
import VueError from "@/components/VueError.vue"
import EditableInput from "@/components/EditableInput.vue"

@Component({
  components: {
    KeyValue,
    Editor,
    LoraParserDelete,
    EnterpriseId,
    SectionHeader,
    Loading,
    VueError,
    EditableInput
  }
})
export default class LoraParserEdit extends Vue{

  name = '';
  loraParser:LoraParser = {} as LoraParser;
  httpBusy:boolean = false;
  httpNameBusy:boolean = false;
  errorMsg = '';
  errorMsgName = '';
  
  curCodeJs = '';
  info:Info = {} as Info;
  currentVersionIndex = 0;

  editorErrorList:{
    severity: 'error' | 'warning',
    message:string, 
    startLine: number,
    startColumn: number,
  }[] = [];

  loraParserNameEditing = false;
  
  // tippies
  cannotChangeVersionTippy?:Instance;
  saveTippy?:Instance;

  iconList:IconList[] = [
    {name:'arrow-left', title:'back to parser list', event:'parser-list', alert: false},
    {name:'flask', title: 'test parser', event:'test'},
    {name:'trash-alt', title: this.canDelete ? 'delete parser' : 'please remove any device association first', event:'delete', alert:true, disabled: !this.canDelete}
  ];

  loraParserNameWaiting = false;

  private coreClient:CoreClient = curCoreClient;

  async mounted() {

    await this.refreshData()

    let inst = tippy('#tippy-version-select', {
      allowHTML: true, 
      content:`Please save or discard your changes first`
    });

    this.cannotChangeVersionTippy = (inst as Instance[])[0];
    this.cannotChangeVersionTippy.disable();

    inst = tippy('#lora-parser-save-tippy');
    this.saveTippy = (inst as Instance[])[0];

  }

  async refreshData(){

    this.httpBusy = true;
    let infoReq = this.coreClient.getInfo();
    let loraParserReq = await this.coreClient.getLoraParser({loraParserId: this.$route.params.loraParserId});
    let infoReply, loraParserReply;

    [infoReply, loraParserReply] = await Promise.all([infoReq,loraParserReq]);

    this.httpBusy = false;

    if(infoReply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(infoReply.errorMsg)
      return this.errorMsg = `Unable to retrieve user info: ${infoReply.errorMsg}`
    
    if(loraParserReply.errorMsg)
      return this.errorMsg = `Unable to retrieve parser ${this.$route.params.loraParserId}: ${loraParserReply.errorMsg}`;

    this.loraParser = loraParserReply.loraParser!;
    this.curCodeJs = loraParserReply.loraParser!.codeJsList[0];
    this.currentVersionIndex = 0;

    this.info = infoReply.info!;
    
    await this.$nextTick();
  }

  async saveLoraParser(){

    this.httpBusy = true;
    this.errorMsg = ""

    const putReply = await this.coreClient.updateLoraParser({loraParserId: this.$route.params.loraParserId, codeJs: this.curCodeJs})

    this.httpBusy = false;

    if(putReply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(putReply.errorMsg)
      return this.errorMsg = `Unable to update: ${putReply.errorMsg}`;

    return this.$router.push({name:'lora-parser-list'});

    //this.refreshData()
  }

  reset() {
    this.curCodeJs = this.loraParser.codeJsList[0];
    this.currentVersionIndex = 0;
  }

  navbarClickHandler(section:'parser-list'|'test'|'delete') {

    switch(section) {
      case 'parser-list':
        return this.$router.push({name:'lora-parser-list'});
      case 'test':
        return this.$router.push({name:'lora-parser-test', params:{loraParserId: this.loraParser.loraParserId}});
      case 'delete':
        return this.$router.push({name:'lora-parser-delete', params:{loraParserId: this.loraParser.loraParserId}});
    }
  }

  updateMarkers(markers:editor.IMarker[]){

    this.editorErrorList = markers
      .filter(marker => marker.severity > monaco.MarkerSeverity.Warning)
      .map(marker => ({
        severity: marker.severity === monaco.MarkerSeverity.Warning ? 'warning' : 'error',
        message: marker.message,
        startLine: marker.startLineNumber,
        startColumn: marker.startColumn
      }))
  }

  async updateLoraParserName(newName:string) {
    
    this.errorMsgName = '';
    this.httpNameBusy = true;
    const putReply = await this.coreClient.updateLoraParser({loraParserId: this.loraParser.loraParserId, name: newName});
    this.httpNameBusy = false;

    if(putReply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(putReply.errorMsg){
      this.errorMsgName = `Unable to update: ${putReply.errorMsg}`;
      this.loraParserNameEditing = true;
      return;
    }

    // we update our local copy
    this.loraParser.name = newName;
  }

  cancel() {
    return this.$router.push({name:'lora-parser-list'});
  }

  get hasUnsavedChanges():boolean {
    return this.loraParser.loraParserId !== undefined && this.curCodeJs !== this.loraParser.codeJsList[0];
  }

  get canReset():boolean {
    return this.loraParser.loraParserId !== undefined && this.curCodeJs !== this.loraParser.codeJsList[0];
  }

  get canSave(){
    const markerErrors = this.editorErrorList.filter(m => m.severity === 'error').length > 0;
    if (markerErrors){
      this.saveTippy && this.saveTippy.setContent("There are errors in the code which must be addressed before you can save")
      return false
    }
    if(this.loraParser.codeJsList[0] === this.curCodeJs){
      this.saveTippy && this.saveTippy.setContent("The code is identical to the latest version")
      return false
    }
    return true
  }

  get canDelete(){
    return !this.httpBusy && this.loraParser && this.loraParser.deviceNum === 0;
  }

  get canCancel() {
    return !this.httpBusy;
  }

  get versionNumberOptions(){
    const latestVersion = this.loraParser.latestVersion;
    const optionsLength = Math.min(latestVersion, 10)
    const ret = [...Array(optionsLength).keys()].map( (v, i) => ({text: '' + (latestVersion - i), value:i}))

    // we add the (latest) flag
    ret[0].text = `${ret[0].text} (latest)`;
    return ret;
  }

  get editorDisabled() {
    return this.httpBusy;
  }

  @Watch("currentVersionIndex")
  async onNewVersionIndex(newVerIndex:number, oldVerIndex:number){

    this.curCodeJs = this.loraParser.codeJsList[newVerIndex]
  }

  get canChangeVersion() {
    return this.curCodeJs === this.loraParser.codeJsList[this.currentVersionIndex] && !this.httpBusy;
  }

  @Watch("curCodeJs")
  async onNewCodeJs(newCodeJs:string, oldCodeJs:string){
    
    // if we have unsaved changes
    if(this.curCodeJs !== this.loraParser.codeJsList[this.currentVersionIndex]) {
      
      if(this.cannotChangeVersionTippy)
        this.cannotChangeVersionTippy.enable();
    } else {

      if(this.cannotChangeVersionTippy)
        this.cannotChangeVersionTippy.disable();
    }
      
    
  }

}


